import type { Maybe, ValueEvent } from '@adornis/base/utilTypes.js';
import { Entity, Field } from '@adornis/baseql/decorators.js';
import type { PartialEntityData } from '@adornis/baseql/entities/types.js';
import { AbstractAspect } from '@adornis/filter/aspect-schemas/AbstractAspect.js';
import type { AspectConfig } from '@adornis/filter/filter-options.js';
import { StudentType } from '@chancenwerk/enums/enums.js';
import { html } from 'lit';

@Entity()
export class StudentTypeAspect extends AbstractAspect {
  static override _class = 'StudentTypeAspect';

  constructor(doc: PartialEntityData<StudentTypeAspect>) {
    const newDoc = {
      fieldName: 'schuelertyp',
      ...doc,
    };
    super(newDoc);
  }

  @Field(() => String) value: Maybe<StudentType>;

  override getMongoFilter(): object | null {
    if (!this.value || !this.fieldName) return null;

    return { [this.fieldName]: this.value };
  }
}

export const StudentTypeAspectSchema: AspectConfig<StudentTypeAspect> = {
  aspectConstructor: StudentTypeAspect,
  renderEditor: ({ aspectValue }) => html`
    <cr-dropdown-selection
      clearable
      placeholder="Schülertyp"
      placeholder-mode="hide"
      .selectables=${Object.values(StudentType)}
      @value-picked=${(e: ValueEvent<Maybe<StudentType>>) => {
        aspectValue.value = e.detail.value ?? null;
      }}
      .value=${aspectValue.value}
    ></cr-dropdown-selection>
  `,
  renderPreview: ({ aspectValue }) => (aspectValue.value ? html` ${aspectValue.value} ` : null),
};
